import { render, staticRenderFns } from "./AdvancedClassView.vue?vue&type=template&id=2681e846&"
import script from "./AdvancedClassView.vue?vue&type=script&lang=js&"
export * from "./AdvancedClassView.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedClassView.vue?vue&type=style&index=0&id=2681e846&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports